var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import makeStyles from '@material-ui/core/styles/makeStyles';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Tooltip from '@material-ui/core/Tooltip';
import { boxShadowGray, lightGray, tooltipGray, themeColor } from '../constants';
;
var InformationTooltip = function (_a) {
    var text = _a.text;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var isMobile = useMediaQuery('(max-width: 800px)');
    var classes = useStyles();
    return (_jsx(ClickAwayListener, __assign({ onClickAway: function () { return setOpen(false); } }, { children: _jsx(Tooltip, __assign({ arrow: true, open: isMobile ? open : undefined, classes: { tooltip: classes.tooltip, arrow: classes.arrow }, title: _jsx("div", __assign({ className: classes.text }, { children: text }), void 0) }, { children: _jsx(HelpOutlineIcon, { color: "primary", fontSize: "small", onClick: function () { return setOpen(function (prev) { return !prev; }); }, className: classes.helpIcon }, void 0) }), "" + isMobile) }), void 0));
};
export default InformationTooltip;
var useStyles = makeStyles({
    text: {
        padding: 6,
        fontSize: '0.85rem',
        color: themeColor,
        borderBottom: "none",
        fontFamily: 'Assistant-Regular',
        lineHeight: '1.2rem'
    },
    helpIcon: {
        verticalAlign: 'middle',
        color: tooltipGray
    },
    tooltip: {
        backgroundColor: lightGray,
        wordBreak: 'break-word',
        boxShadow: "0px 3px 6px " + boxShadowGray,
        borderRadius: '2vh',
        marginTop: '2vh'
    },
    arrow: {
        "&::before": {
            backgroundColor: lightGray
        }
    }
});
//# sourceMappingURL=InformationTooltip.js.map